export default __webpack_public_path__ + "static/media/books-62.bc256294.jpg";